var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('source-form',{on:{"on-refresh":function($event){return _vm.$emit('on-refresh')}}}),_c('source-table',{attrs:{"patterns":_vm.patterns},on:{"on-refresh":function($event){return _vm.$emit('on-refresh')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }